<template>
    <div class="container">
        <div class="page-content mt-10">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        {{ $t('trading.title') }}
                    </h1>
                </div>

                <div class="col-12 mb-4" style="white-space: nowrap">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation" v-on:click="tab = 'received'">
                            <h5 class="nav-link active" id="received-tab" data-bs-toggle="tab" data-bs-target="#received" type="button" role="tab" aria-controls="received" aria-selected="true">
                                {{ $t('trading.tabs.inbox') }}
                            </h5>
                        </li>
                        <li class="nav-item" role="presentation" v-on:click="tab = 'own'">
                            <h5 class="nav-link" id="own-tab" data-bs-toggle="tab" data-bs-target="#own" type="button" role="tab" aria-controls="own" aria-selected="false">
                                {{ $t('trading.tabs.sent') }}
                            </h5>
                        </li>
                        <li class="nav-item" role="presentation" v-on:click="tab = 'new'">
                            <h5 class="nav-link" id="new-tab" data-bs-toggle="tab" data-bs-target="#new" type="button" role="tab" aria-controls="new" aria-selected="false">
                                {{ $t('trading.tabs.new') }}
                            </h5>
                        </li>
                        <li class="nav-item" role="presentation" v-on:click="tab = 'wishlist'" v-if="$store.state.user?.wishlist?.length > 0">
                            <h5 class="nav-link" id="wishlist-tab" data-bs-toggle="tab" data-bs-target="#wishlist" type="button" role="tab" aria-controls="wishlist" aria-selected="false">
                                {{ $t('trading.tabs.wishlist') }}
                            </h5>
                        </li>
                    </ul>
                </div>

                <div v-show="tab === 'received'" class="row p-0">
                    <div class="col-12">
                        <h3>{{ $t('trading.received') }}</h3>
                    </div>

                    <div class="col-12 mt-2" v-if="receivedOffers.length === 0">
                        <p class="alert alert-info">{{ $t('trading.noOffersPending') }}</p>
                    </div>

                    <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12" v-for="offer in receivedOffers">
                        <div class="card bg-black text-white mb-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-7 ps-0">
                                        <label>{{ $t('trading.offeredBy') }}</label>
                                        <h5 v-text="offer.user.username"></h5>

                                        <label>{{ $t('trading.cardName') }}</label>
                                        <h5 v-text="offer.offered_card.name"></h5>

                                        <label>{{ $t('trading.set') }}</label>
                                        <h5>
                                            {{ offer.offered_card.set.name }}<br/>
                                            <small class="muted pt-0 mt-0" style="font-size: 0.6em">{{ offer.offered_card.set.series }}</small>
                                        </h5>


                                        <label>{{ $t('trading.inCollection') }}</label>
                                        <h5>{{ offer.offered_card.is_in_set_collection ? 'YES' : 'NO' }}</h5>
                                        <div class="row p-0" v-if="offer.counter_offered_card_id">
                                            <div class="col-7 ps-0">
                                                {{ $t('trading.youOffered') }}:

                                                <h4 v-text="offer.counter_offered_card.name"></h4>
                                            </div>
                                            <div class="col-5 pe-0">
                                                <img v-on:click="showCardCanvas(offer.counter_offered_card)" :src="CardService.getSmallCardImageUrl(offer.counter_offered_card)" alt="counter offer thumbnail" class="w-100">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-5 pe-0 text-center">
                                        <img v-on:click="showCardCanvas(offer.offered_card)" :src="CardService.getSmallCardImageUrl(offer.offered_card)" alt="offered card thumbnail" class="w-100"><br/>
                                        <img :src="CardService.getSetLogoUrl(offer.offered_card)" alt="offered card set logo" class="w-100 mt-2">
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="row" v-if="offer.status === status.STATUS_SENT">
                                    <div class="col-6 ps-0">
                                        <a href="javascript:" v-on:click="confirmDenialOfOrder(offer)" class="btn btn-danger w-100">
                                            {{ $t('trading.deny') }}
                                        </a>
                                    </div>

                                    <div class="col-6 pe-0">
                                        <a href="javascript:" v-on:click="answerOffer(offer)" class="btn btn-success w-100">
                                            {{ $t('trading.answer') }}
                                        </a>
                                    </div>
                                </div>
                                <div class="row" v-if="offer.status === status.STATUS_ANSWERED">
                                    <div class="col-12 px-0">
                                        <a href="javascript:" class="btn btn-danger w-100" v-on:click="confirmDenialOfOrder(offer)">{{ $t('trading.cancelOffer') }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-show="tab === 'own'" class="row p-0">
                    <div class="col-12">
                        <h3>{{ $t('trading.sentOffers') }}</h3>
                    </div>

                    <div class="col-12 mt-2" v-if="ownOffers.length === 0">
                        <p class="alert alert-info">{{ $t('trading.noSentOffers') }}</p>
                    </div>

                    <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12" v-for="offer in ownOffers">
                        <div class="card bg-black text-white mb-2">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-7 ps-0">
                                        <label>{{ $t('trading.offeredTo') }}</label>
                                        <h5 v-text="offer.target_user.username"></h5>

                                        <label>{{ $t('trading.cardName') }}</label>
                                        <h5 v-text="offer.offered_card.name"></h5>

                                        <label>{{ $t('trading.set') }}</label>
                                        <h5>
                                            {{ offer.offered_card.set.name }}<br/>
                                            <small class="muted pt-0 mt-0" style="font-size: 0.6em">{{ offer.offered_card.set.series }}</small>
                                        </h5>
                                        <div class="row p-0" v-if="offer.counter_offered_card_id">
                                            <div class="col-7 ps-0">
                                                {{ $t('trading.theirOffer') }}:

                                                <h4 v-text="offer.counter_offered_card.name"></h4>
                                            </div>
                                            <div class="col-5 pe-0">
                                                <img v-on:click="showCardCanvas(offer.counter_offered_card)" :src="CardService.getSmallCardImageUrl(offer.counter_offered_card)" alt="counter offer thumbnail" class="w-100">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-5 pe-0 text-center">
                                        <img v-on:click="showCardCanvas(offer.offered_card)" :src="CardService.getSmallCardImageUrl(offer.offered_card)" alt="offered card thumbnail" class="w-100"><br/>
                                        <img :src="CardService.getSetLogoUrl(offer.offered_card)" alt="offered card set logo" class="w-100 mt-2">
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="row" v-if="offer.status === status.STATUS_SENT">
                                    <div class="col-12 px-0">
                                        <a href="javascript:" class="btn btn-danger w-100" v-on:click="confirmDenialOfOrder(offer)">
                                            {{ $t('trading.cancelOffer') }}
                                        </a>
                                    </div>
                                </div>

                                <div class="row" v-if="offer.status === status.STATUS_ANSWERED">
                                    <div class="col-6 ps-0">
                                        <a href="javascript:" class="btn btn-danger w-100" v-on:click="confirmDenialOfOrder(offer)">
                                            {{ $t('trading.deny') }}
                                        </a>
                                    </div>

                                    <div class="col-6 pe-0">
                                        <a href="javascript:" class="btn btn-success w-100" v-on:click="approveCounterOffer(offer)">
                                            {{ $t('trading.approve') }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12" v-show="tab === 'new'">
                    <div class="col-12">
                        <h3>{{ $t('trading.makeOffer') }}</h3>
                    </div>

                    <div class="col-12 my-3">
                        <div class="form-group px-1">
                            <input type="search" class="form-control" v-model="userSearch" :placeholder="$t('trading.searchUser')">
                        </div>
                    </div>

                    <div class="col-12 p-0">
                        <template v-for="user in userList">
                            <div v-if="!userSearch || user.username.toLowerCase().search(userSearch.toLowerCase()) >= 0 || userSearch === '💩' && user.username === 'mrtoastbrot09'" class="card bg-black text-white mb-2">
                                <div class="card-body w-100">
                                    <span class="btn btn-sm btn-success float-end" v-on:click="makeOffer(user)">{{ $t('trading.offer') }}</span>

                                    <div class="avatar-image d-inline-block me-1">
                                        <img :src="'/assets/dipocaco/avatars/'+user.account.avatar.filename" alt="">
                                    </div>

                                    <div class="d-inline-block ms-2 w-auto">
                                        <h4 class="mt-1 mb-0">{{ user.username }}</h4>
                                        <span class="mt-0 d-block">
                                        Level <strong class="mr-2">{{ getUserLevel(user) }}</strong>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="col-12 row p-0" v-show="tab === 'wishlist'" v-if="$store.state.user?.wishlist?.length > 0">
                    <div class="col-12">
                        <h3>{{ $t('trading.yourWishlist') }}</h3>
                    </div>

                    <div v-for="wishlistCard in $store.state.user.wishlist" class="col-xxl-1 col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4 mb-3 text-center">
                        <a href="javascript:" class="text-left mb-2" v-on:click="showCardCanvas(wishlistCard)">
                            <img loading="lazy" :src="CardService.getSmallCardImageUrl(wishlistCard)" style="width: auto; max-width: 100%;" class="card-thumbnail" alt="card-thumbnail">
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="offcanvas offcanvas-end" id="card-offer-canvas" tabindex="-1" role="dialog" aria-labelledby="card-offer-canvas-label" aria-hidden="true">
            <div class="offcanvas-header">
                <h3 class="text-center text-dark w-100" v-if="offerToAnswer">{{ $t('trading.answerOffer') }}</h3>
                <h3 class="text-center text-dark w-100" v-if="selectedUser">{{ $t('trading.makeOfferTo', {name: selectedUser.username}) }}</h3>
            </div>

            <div class="offcanvas-body">
                <p class="alert alert-info">
                    {{ $t('trading.selectCard', {name: offerToAnswer ? offerToAnswer.user.username : selectedUser?.username}) }}
                </p>

                <div class="row m-0 counter-offer-selection">
                    <div class="col-12" v-if="targetUserWishlistOwnedCards.length > 0">
                        <h5>{{ $t('trading.theirWishlist') }}</h5>
                    </div>

                    <a class="col-4 pb-2" v-for="card in targetUserWishlistOwnedCards" :key="card.id" v-on:click="selectedCardToOffer = card">
                        <img :src="CardService.getSmallCardImageUrl(card)" :alt="card.name+' thumbnail'" :class="'w-100'+(selectedCardToOffer?.id === card.id ? ' selected-answer-card' : '')">
                    </a>

                    <div class="col-12" v-if="targetUserWishlistOwnedCards.length > 0">
                        <hr/>
                    </div>

                    <a class="col-4 pb-2" v-for="card in $store.state.collection.cards" :key="card.id" v-on:click="selectedCardToOffer = card">
                        <img :src="CardService.getSmallCardImageUrl(card)" :alt="card.name+' thumbnail'" :class="'w-100'+(selectedCardToOffer?.id === card.id ? ' selected-answer-card' : '')">
                    </a>
                </div>

                <a href="javascript:" class="mt-2 btn btn-danger w-100" v-on:click="closeModal()">Cancel</a>
                <a href="javascript:" class="mt-1 btn btn-success w-100" v-if="selectedCardToOffer" v-on:click="sendOffer">
                    {{ $t('trading.answerOffer', {card: selectedCardToOffer ? selectedCardToOffer.name : ''}) }}
                </a>
            </div>
        </div>

        <card-detail-view-canvas :card="selectedCardToShow" :gallery="true"></card-detail-view-canvas>
    </div>
</template>

<script>
import CardService from "../../CardService";
import iziToast from "izitoast";
import axios from "axios";
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";

export default {
    name: "Trading",
    components: {CardDetailViewCanvas},
    data() {
        return {
            tab: 'received',
            offerToAnswer: null,
            selectedUser: null,
            selectedCardToOffer: null,
            selectedCardToShow: null,
            userSearch: null,
            ownOffers: [],
            receivedOffers: [],
            userList: [],
            status: {
                STATUS_SENT: 0,
                STATUS_DENIED_BY_RECEIVER: 1,
                STATUS_ANSWERED: 2,
                STATUS_DENIED_BY_SENDER: 3,
                STATUS_COMPLETED: 4,
                STATUS_CANCELLED: 5,
            },
            targetUserWishlist: [],
            routeActionDone: false
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.$store.commit('updateUserCards');
        this.fetchOwnOffers();
        this.fetchReceivedOffers();
        this.fetchUserList();


        if (this.$route.params.tab) {
            document.querySelector('#'+this.$route.params.tab+'-tab').click()
            this.tab = this.$route.params.tab;
        }

        if (this.$route.params.user) {
            this.userSearch = this.$route.params.user;
        } else if (localStorage.getItem('dipocaco_set_filter')) {
            this.setFilter = localStorage.getItem('dipocaco_set_filter');
        }
    },
    computed: {
        CardService() {
            return CardService
        },
        targetUserWishlistOwnedCards() {
            return this.$store.state.collection.cards.filter(c => this.targetUserWishlist.includes(c.id));
        }
    },
    methods: {
        showCardCanvas(card) {
            this.selectedCardToShow = card;
            this.$store.commit('updateUserWishlist');

            setTimeout(() => {
                $("#card-detail-view-canvas").offcanvas('toggle');
            }, 100)
        },
        fetchOwnOffers() {
            fetch('/api/trades/own').then(r => r.json()).then((response) => {
                this.ownOffers = response.map(offer => {
                    offer.offered_card.json = JSON.parse(offer.offered_card.json);
                    offer.offered_card.set = offer.offered_card.json.set;
                    return offer;
                })

                this.ownOffers.forEach(offer => {
                    fetch('/api/cards/in-collection/'+offer.offered_card.id).then((response) => {
                        offer.offered_card.is_in_set_collection = response;
                    })

                    if (offer.counter_offered_card_id) {
                        fetch('/api/cards/in-collection/'+offer.counter_offered_card.id).then((response) => {
                            offer.counter_offered_card.is_in_set_collection = response;
                        })
                    }
                })
            })
        },
        fetchReceivedOffers() {
            fetch('/api/trades/received').then(r => r.json()).then((response) => {
                this.receivedOffers = response.map(offer => {
                    offer.offered_card.json = JSON.parse(offer.offered_card.json);
                    offer.offered_card.set = offer.offered_card.json.set;
                    return offer;
                })

                this.receivedOffers.forEach(offer => {
                    fetch('/api/cards/in-collection/'+offer.offered_card.id).then((response) => {
                        offer.offered_card.is_in_set_collection = response;
                    })

                    if (offer.counter_offered_card_id) {
                        fetch('/api/cards/in-collection/'+offer.counter_offered_card.id).then((response) => {
                            offer.counter_offered_card.is_in_set_collection = response;
                        })
                    }
                })
            })
        },
        closeModal() {
            $("#card-offer-canvas").offcanvas('hide');

            this.offerToAnswer = null;
            this.selectedUser = null;
            this.selectedCardToOffer = null;
            this.$store.commit('updateUserCards');
        },
        answerOffer(offer) {
            this.offerToAnswer = offer;
            this.getUserWishlist(this.offerToAnswer.user.id);
            $("#card-offer-canvas").offcanvas('toggle');
        },
        makeOffer(user) {
            this.selectedUser = user;
            this.getUserWishlist(this.selectedUser.id);
            $("#card-offer-canvas").offcanvas('toggle');
        },
        approveCounterOffer(offer) {
            axios.post('/api/trades/approve', {
                offer: offer.id
            }).then((response) => {
                iziToast.success({title: response.data.message});
                this.fetchReceivedOffers();
                this.fetchOwnOffers();
            });
        },
        sendOffer() {
            if (this.offerToAnswer) {
                axios.post('/api/trades/answer', {
                    offer: this.offerToAnswer.id,
                    counter_offered_card_id: this.selectedCardToOffer.id,
                }).then((response) => {
                    this.closeModal();
                    iziToast.success({title: response.data.message});
                    this.fetchReceivedOffers();
                    this.fetchOwnOffers();
                });
            } else {
                axios.post('/api/trades/create', {
                    user: this.selectedUser.id,
                    offered_card_id: this.selectedCardToOffer.id,
                }).then((response) => {
                    this.closeModal();
                    iziToast.success({title: response.data.message});
                    this.fetchReceivedOffers();
                    this.fetchOwnOffers();
                });
            }
        },
        confirmDenialOfOrder(offer) {
            let vue = this;
            let message = this.$i18n.t('trading.notifications.denyOfferBy', {name: offer.user.username});

            if (offer.user_id === this.$store.state.user.user_id && (offer.status === this.status.STATUS_SENT || offer.status === this.status.STATUS_ANSWERED)) {
                message = this.$i18n.t('trading.notifications.cancelOfferTo', {name: offer.target_user.username})
            }

            iziToast.question({
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: 'once',
                id: 'question',
                zindex: 999,
                message: message,
                position: 'center',
                color: 'red',
                buttons: [
                    [
                        '<button><b>Yes</b></button>',
                        function (instance, toast) {
                            instance.hide({transitionOut: 'fadeOut'}, toast, 'button');

                            axios.post('/api/trades/deny', {
                                offer: offer.id,
                            }).then((response) => {
                                iziToast.success({title: response.data.message});
                                vue.fetchReceivedOffers();
                                vue.fetchOwnOffers();
                            });
                        }, true
                    ], [
                        '<button>No</button>',
                        function (instance, toast) {
                            instance.hide({transitionOut: 'fadeOut'}, toast, 'button');
                        }
                    ],
                ],
            })
        },
        fetchUserList() {
            axios.get('/api/users/list').then((response) => {
                this.userList = response.data;

                if (!this.routeActionDone && this.$route.params.user) {
                    setTimeout(() => {
                        // console.log(this.userList.find(u => u.id === this.$route.params.user))
                        this.makeOffer(this.userList.find(u => u.username === this.$route.params.user));
                    }, 1000)
                }
            })
        },
        getUserLevel(profileData) {
            return (profileData.account.xp - (profileData.account.xp % 20_000)) / 20_000 + 1;
        },
        getUserWishlist(userId) {
            axios.get('/api/user/wishlist/'+userId).then((response) => {
                this.targetUserWishlist = response.data.map(c => c.card_id);

                if (!this.routeActionDone && this.$route.params.card) {
                    this.selectedCardToOffer = this.$store.state.collection.cards.find(c => c.id === this.$route.params.card);
                    this.routeActionDone = true;
                }

                this.$forceUpdate();
            })
        },
    },
};
</script>


<style scoped lang="scss">
.page-heading {
    background-image: url(/assets/dipocaco/pocas/trading-poca_sm.jpg);
    background-position: center 45%;
}

.counter-offer-selection {
    max-height: 57.5vh;
    overflow-y: auto;
}

.selected-answer-card {
    filter: drop-shadow(0px 4px 8px rgba(15, 253, 253, 0.70));
}

.avatar-image {
    vertical-align: top;
    display: inline-block;
    max-width: 40%;
    border-radius: 1000px;
    border: 2px solid black;
    background-color: grey;

    img {
        max-width: 100%;
        max-height: 4em;
    }
}

.search-result {
    text-decoration: none;
}
</style>
